import styled from "@emotion/styled";
import { ALWAYS_ON_TOP } from "constants/z-index";
import BasicHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
import Colors from "styles/colors";
const BASIC_HEADER_HEIGHT = `${BasicHeaderConstants.BASIC_HEADER_HEIGHT}px`;
const HEADER_FADE_DURATION_MS = 300;
export const StyledSubmenuHeaderBar = styled.div`
  position: fixed;
  top: -1px;
  width: 100vw;
  height: ${BASIC_HEADER_HEIGHT};
  z-index: ${ALWAYS_ON_TOP};
  background: ${Colors["white"]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-sizing: border-box;
  opacity: 0;
  pointer-events: none;
  transition: opacity ${HEADER_FADE_DURATION_MS}ms ease;

  &.is-visible {
    opacity: 1;
    pointer-events: auto;
    animation: submenu-header-fade-in ${HEADER_FADE_DURATION_MS}ms ease;
  }

  @keyframes submenu-header-fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .submenu-header-back {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    .arrow-left-icon {
      width: 28px;
      height: 28px;
    }
  }

  .submenu-header-title {
    font-size: 1.25rem;
    font-weight: 400;
    color: ${Colors["Black"]};
  }

  .submenu-header-close {
    position: relative;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    width: 28px;
    height: 36px;

    .close-line {
      display: block;
      position: absolute;
      top: 18px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${Colors["black"]};
      border-radius: 4px;

      &:nth-child(1) {
        transform: rotate(45deg);
      }

      &:nth-child(2) {
        transform: rotate(-45deg);
      }
    }
  }
`;
